import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HelperService } from 'src/app/shared/utils/helper.service';

@Injectable()
export class AddTokenInterceptor implements HttpInterceptor {
  constructor(private helperService: HelperService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes("s3")) return next.handle(req);
    return this.helperService.getToken().pipe(
      mergeMap((token) => {
        if (token) {
          req = req.clone({
            setHeaders: { Authorization: token },
          });
        } else {
          req = req.clone({
            setHeaders: { Authorization: 'NO_AUTHENTICATION' },
          });
        }
        return next.handle(req);
      })
    );
  }
}
